<script setup lang="ts">
import { MMLink, MMText, MMIcon, MMPopupDefault } from '@mm-frontend/mm-web-ui-kit'
import { useAppFooter } from '~/features/footer/business/appFooter.composable'

const { config } = useAppFooter()
</script>

<template>
  <MMPopupDefault class="contacts-modal">
    <template #header>
      <MMText font="Headline M/Bold">Связаться с нами</MMText>
      <MMText font="Body M/Regular">Задайте вопрос нашим специалистам в чате удобной вам социальной сети</MMText>
    </template>

    <div class="contacts-modal__social-links">
      <MMLink
        v-for="link in config.social" 
        :key="link.title" 
        :to="link.to" 
        target="_blank"
        class="contacts-modal__social-links__item"
        underline="none"
      >
        <MMIcon v-if="link.icon" :name="link.icon" :height="48" :width="48" />
        <div>
          <MMText font="Body M/Medium">{{ link.title }}</MMText>
          <MMText v-if="link.description" font="Caption L/Regular" color="secondary">{{ link.description }}</MMText>
        </div>
      </MMLink>

      <MMLink
        class="contacts-modal__social-links__item"
        :to="`tel:${config.support.phone}`"
        target="_blank"
        underline="none"
      >
        <MMIcon name="social-phone" :height="48" :width="48" />
        <div>
          <MMText font="Body M/Medium">{{ config.support.phone }}</MMText>
          <MMText font="Caption L/Regular" color="secondary">{{ config.support.description }}</MMText>
        </div>
      </MMLink>
    </div>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.contacts-modal
  &__social-links
    display flex
    flex-direction column
    margin-top 16px
    margin-bottom 16px

    &__item
      display flex
      align-items center
      gap 16px
      width 100%
      padding 8px 12px
      box-sizing border-box
      border-radius 12px
      transition background-color var(--default-transition-duration) var(--default-transition-timing-function)

      &:hover
        background-color var(--background-secondary)

  &__email
    display flex
    flex-direction column
    align-items flex-start
</style>
